import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("a", {
  href: "/help/usingthesite",
  class: "box border-rounded"
}, [
  /*#__PURE__*/_createElementVNode("h3", null, "Using the Site")
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("a", {
  href: "/help/dashboards",
  class: "box border-rounded"
}, [
  /*#__PURE__*/_createElementVNode("h3", null, "Dashboards")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", {
  href: "/help/faqs",
  class: "box border-rounded"
}, [
  /*#__PURE__*/_createElementVNode("h3", null, "FAQs")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("a", {
  href: "/help/changelog",
  class: "box border-rounded"
}, [
  /*#__PURE__*/_createElementVNode("h3", null, "Change Log")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", null, "Change Log", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "" }, " Here is a summary of the changes made in each release of the software. ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "changelog_date" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "c_date" }, [
    /*#__PURE__*/_createElementVNode("h6", null, "October 2021 "),
    /*#__PURE__*/_createElementVNode("p", null, "MxB-DS v1.0")
  ])
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "version_info" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "c_version" }, " 1.0 "),
  /*#__PURE__*/_createElementVNode("div", { class: "line bottom_half" })
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "changelog_content" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("span", { class: "new" }, "New"),
    /*#__PURE__*/_createTextVNode("Version 1.0 launched")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("span", { class: "new" }, "New"),
    /*#__PURE__*/_createTextVNode("Help Section Added")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_DashboardLayout = _resolveComponent("DashboardLayout")!

  return (_openBlock(), _createBlock(_component_DashboardLayout, null, {
    header: _withCtx(() => [
      _createVNode(_component_el_row, {
        gutter: 20,
        class: "pad-v-20"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 6 }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    content: _withCtx(() => [
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 24 }, {
            default: _withCtx(() => [
              _hoisted_5,
              _hoisted_6
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, { gutter: 20 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, {
            span: 6,
            class: "changelog_info"
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 4 }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 14 }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}